import { configureStore } from "@reduxjs/toolkit";
import TicketSlice from "./redux/ticketSlice";
import ticketAssignSlice from "./redux/ticketAssignSlice";
import complianceSlice from "./redux/complianceSlice";
import ll55Slice from "./redux/ll55Slice";
import buildingStatsSlice from "./redux/buildingStatsSlice";

const store = configureStore({
  reducer: {
    ticket: TicketSlice,
    assignTicket: ticketAssignSlice,
    compliance: complianceSlice,
    ll55: ll55Slice,
    buildingStats: buildingStatsSlice,
  },
  // middleware: (getDefaultMiddleware) =>
  //   getDefaultMiddleware().concat(conditionMiddleware),
});

export default store;
